export default __webpack_public_path__ + "static/media/vox-img-legacy-009.78859349.jpg";